module.exports = __webpack_public_path__ + "img/inbox.98047505.gif";